// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta la instancia de Auth
export const auth = getAuth(app);

// Configurar persistencia explícitamente para mantener la sesión al recargar
// browserLocalPersistence es el valor por defecto, pero lo configuramos explícitamente
// para asegurar que la sesión se mantenga entre recargas de página
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("✅ Persistencia de Firebase configurada correctamente");
  })
  .catch((error) => {
    console.error("❌ Error al configurar persistencia de Firebase:", error);
  });
